import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { getErrorMessage } from '@/lib/apiError';

interface CambioContadorConfirmacionDialogProps {
  open: boolean;
  valorActual: number;
  nuevoValor: number;
  isPending: boolean;
  error: unknown;
  onConfirm: () => void;
  onCancel: () => void;
}

export function CambioContadorConfirmacionDialog({
  open,
  valorActual,
  nuevoValor,
  isPending,
  error,
  onConfirm,
  onCancel,
}: CambioContadorConfirmacionDialogProps): JSX.Element {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={isPending ? undefined : onCancel}>
      <DialogTitle>Confirmar cambio de numeración</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Estás por cambiar el contador de protocolos de{' '}
          <strong>{valorActual}</strong> a <strong>{nuevoValor}</strong>.
        </DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>
          El próximo protocolo creado será el N° <strong>{nuevoValor + 1}</strong>.
        </DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>
          Este cambio puede afectar la numeración futura del sistema. ¿Confirmás?
        </DialogContentText>
        {error != null && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {getErrorMessage(error)}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isPending}>
          Cancelar
        </Button>
        <Button
          color="warning"
          variant="contained"
          disabled={isPending}
          onClick={onConfirm}
          startIcon={isPending ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {isPending ? 'Guardando...' : 'Confirmar cambio'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
